<template>
  <section class="hero is-medium background">
    <div class="hero-body">
      <div class="container">
        <div class="columns has-text-centered">
          <div class="column">
            <h1 class="headingz">Welcome!</h1>
            <section class="section is-small">
              <div class="columns is-vcentered">
                <div class="column">
                  <p
                    class="has-text-white has-text-left is-roboto-regular px-0 py-0"
                  >
                    If you are a dealer or distributor and would like access to
                    the DVO B2B portal please email admin@dvosuspension.com to
                    get your account set up!
                  </p>
                </div>
                <div class="column has-line">
                  <div>
                  <b-tabs class="has-background-dvodark" position="is-centered">
                      <b-tab-item class="has-background-dvodark" label="Login" icon="login-variant">
                      <SignIn/>
                      </b-tab-item>
                      <b-tab-item class="has-background-dvodark" label="Sign Up" icon="account-circle">
                      <SignUp/>
                      </b-tab-item>
                  </b-tabs>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SignIn from '../views/auth/SignIn'
import SignUp from '../views/auth/SignUp'

export default {
  components:{
    SignIn,
    SignUp
  },
  data() {
    return {
      email: null,
      username: null,
      password: null,
      error: null,
      phone_number: null,
      authState: null,
      user: null,
    };
  },
  created() {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

amplify-authenticator {
  display: inline-block;
  height: 20vh;
}

h1 {
  font-family: "Anton", sans-serif;
}

p {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
}

.headingz {
  font-size: 5rem;
  color: #d0cfce;
}

.is-roboto-regular {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 16pt;
}

.has-line {
  border-left: 2px solid white;
}
</style>